import { render, staticRenderFns } from "./ProjectFullAds.vue?vue&type=template&id=293efea6"
import script from "./ProjectFullAds.vue?vue&type=script&lang=js"
export * from "./ProjectFullAds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports